export default async function ({ app, store }) {
  if (!store.state.topics.list.length) app.store.dispatch('courses/GET_TOPICS');
}
